<template>
  <nav class="breadcrumbs" aria-label="Breadcrumb">
    <ol itemscope itemtype="https://schema.org/BreadcrumbList">
      <li itemprop="itemListElement" itemscope itemtype="https://schema.org/ListItem">
        <a itemprop="item" href="/">
          <span itemprop="name">Home</span>
        </a>
        <meta itemprop="position" content="1">
      </li>
      <li v-for="(item, index) in items" :key="index" itemprop="itemListElement" itemscope itemtype="https://schema.org/ListItem">
        <span class="separator">/</span>
        <a v-if="item.url" itemprop="item" :href="item.url">
          <span itemprop="name">{{ item.name }}</span>
        </a>
        <span v-else itemprop="name" class="current-page">{{ item.name }}</span>
        <meta itemprop="position" :content="index + 2">
      </li>
    </ol>
  </nav>
</template>

<script>
export default {
  name: 'Breadcrumbs',
  props: {
    items: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  mounted() {
    this.injectSchema();
  },
  methods: {
    injectSchema() {
      const schema = {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        "itemListElement": [
          {
            "@type": "ListItem",
            "position": 1,
            "name": "Home",
            "item": "https://gbappsdl.org/"
          },
          ...this.items.map((item, index) => ({
            "@type": "ListItem",
            "position": index + 2,
            "name": item.name,
            "item": item.url ? `https://gbappsdl.org${item.url}` : window.location.href
          }))
        ]
      };

      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.text = JSON.stringify(schema);
      document.head.appendChild(script);
    }
  }
}
</script>

<style scoped>
.breadcrumbs {
  padding: 15px 100px;
  background-color: #f8f9fa;
  font-size: 0.95rem;
  border-bottom: 1px solid #eaeaea;
}

.breadcrumbs ol {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;
}

.breadcrumbs li {
  display: flex;
  align-items: center;
}

.breadcrumbs a {
  color: #4A5568;
  text-decoration: none;
  transition: color 0.3s ease;
}

.breadcrumbs a:hover {
  color: #25D366;
  text-decoration: underline;
}

.breadcrumbs .separator {
  margin: 0 10px;
  color: #A0AEC0;
}

.breadcrumbs .current-page {
  color: #121212;
  font-weight: 600;
}
</style>
